import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { createBinaryString } from '@constants/funtions-utils';

export interface IssueChangeEvent {
  issueType: number;
  agudo?: boolean;
  issueDueDateMEC?: Date | null;
}

@Component({
  selector: 'app-re-issues',
  templateUrl: './re-issues.component.html',
  styleUrls: ['./re-issues.component.scss']
})
export class ReIssuesComponent implements OnChanges{

  @Input() issueType: number;
  @Input() agudo: boolean = false;
  @Input() issueDueDateMEC: Date | null = null;
  @Input() disabled: boolean = false;
  @Output() issueChange: EventEmitter<IssueChangeEvent> = new EventEmitter();

  public flags = {
    0: false,
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
  }

  public activePopover: 4 | 5 | null = null;
  public popoverAgudo: boolean = false;
  public popoverDate: Date | null = null;
  public popoverPosition = { top: 0, left: 0 };
  public today = new Date();

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:mousedown', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.activePopover === null) return;
    const target = event.target as HTMLElement;
    if (this.elementRef.nativeElement.contains(target)) return;
    if (target.closest('.cdk-overlay-container')) return;
    this.cancelPopover();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['issueType']) {
      this.getIssueFlag(changes['issueType'].currentValue || 0);
    }
    if (changes['agudo']) {
      this.popoverAgudo = changes['agudo'].currentValue || false;
    }
    if (changes['issueDueDateMEC']) {
      this.popoverDate = changes['issueDueDateMEC'].currentValue || null;
    }
  }

  getIssueFlag(number: number): void {
    const flag = createBinaryString(number);
    const l = flag.length - 1;
    this.flags[0] = flag[l - 0] === '1' || flag[l - 1] === '1';
    this.flags[2] = flag[l - 2] === '1';
    this.flags[3] = flag[l - 3] === '1';
    this.flags[4] = flag[l - 4] === '1';
    this.flags[5] = flag[l - 5] === '1';
    this.flags[6] = flag[l - 6] === '1';
    this.flags[7] = flag[l - 7] === '1';
  }

  getIssueType(): number {
    const flags = Object.values(this.flags);
    let result = 0;
    flags.forEach((val, i) => {
      result += val ? Math.pow(2, i) : 0;
    })
    return result;
  }

  onFlagClick(flag: 0|1|2|3|4|5|6|7, event: MouseEvent): void {
    if (this.disabled) return;

    if (flag === 4 || flag === 5) {
      const willActivate = !this.flags[flag];
      if (willActivate) {
        const target = event.currentTarget as HTMLElement;
        const rect = target.getBoundingClientRect();
        this.popoverPosition = {
          top: rect.bottom + 6,
          left: rect.left + rect.width / 2,
        };
        this.activePopover = flag;
        if (flag === 4) {
          this.popoverAgudo = this.agudo || false;
        }
        if (flag === 5) {
          this.popoverDate = this.issueDueDateMEC || null;
        }
        return;
      }
    }

    this.flags[flag] = !this.flags[flag];
    this.activePopover = null;
    const res = this.getIssueType();
    this.issueChange.emit({ issueType: res });
  }

  confirmPopover(): void {
    if (this.activePopover === 4) {
      this.flags[4] = true;
      const res = this.getIssueType();
      this.issueChange.emit({ issueType: res, agudo: this.popoverAgudo });
    } else if (this.activePopover === 5) {
      this.flags[5] = true;
      const res = this.getIssueType();
      this.issueChange.emit({ issueType: res, issueDueDateMEC: this.popoverDate });
    }
    this.activePopover = null;
  }

  cancelPopover(): void {
    this.activePopover = null;
  }

  getTooltip5(): string {
    let text = 'No en RE';
    if (this.flags[4] && this.agudo) {
      text += ' (Agudo)';
    }
    return text;
  }

  getTooltip6(): string {
    let text = 'Falta validación';
    if (this.flags[5] && this.issueDueDateMEC) {
      const d = new Date(this.issueDueDateMEC);
      text += ` (${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()})`;
    }
    return text;
  }
}
